export default __webpack_public_path__ + "static/IBMPlexSans-Light-Greek-2c9f4d67204c245014f643cb9db3076c.woff";